const getters = {
    token: state => state.user.token,
    domain: state => state.tougao.domain,
    tougaoInfo: state => state.tougao.tougaoInfo,
    tougaoSetting: state => state.tougao.tougaoSetting,
    memberSetting: state => state.tougao.memberSetting,
    memberSettingEn: state => state.tougao.memberSettingEn,
    zuopinSetting: state => state.tougao.zuopinSetting,
    zuopinSettingEn: state => state.tougao.zuopinSettingEn,
    bannerList: state => state.tougao.bannerList,
    categoryList: state => state.tougao.categoryList,
    categoryListEn: state => state.tougao.categoryListEn,
    examInfo: state => state.exam.examInfo,
    examBannerList: state => state.exam.examBannerList,
    subjectList: state => state.exam.subjectList,
    openid: state => state.wechat.openid,
    language: state => state.app.language
}
export default getters
